import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_SUB_ACCOUNT = ({
  canReadClientLowRiskPii,
  canReadBillingSchedule,
  canReadFeeTier,
}: {
  canReadClientLowRiskPii: boolean;
  canReadBillingSchedule: boolean;
  canReadFeeTier: boolean;
}) => gql`
  query fetchSubAccount($id: ObjectID!) {
    fetchSubAccount(subAccountId: $id) {
      subAccount {
        id
        name
        state
        liquidated
        createdAt
        tradingProcess
        calculatedSuitabilityScore
        account {
          id
          type
          user {
            id
            ${canReadClientLowRiskPii ? 'firstName' : ''}
            ${canReadClientLowRiskPii ? 'middleName' : ''}
            ${canReadClientLowRiskPii ? 'lastName' : ''}
            organization {
              id
            }
            statistics {
              marketValueCents
            }
            subAccounts {
              id
              account {
                type
              }
              goal {
                name
              }
              financialProduct {
                translatedName { ${TRANSLATED_STRING_FIELDS} }
              }
            }
          }
          householdClientGroup {
            id
            financialProduct {
              id
            }
          }
        }
        goal {
          id
          name
          financialProduct {
            id
            translatedName { ${TRANSLATED_STRING_FIELDS} }
            theme {
              id
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
          }
        }
        skipIPS
        allowClientDeposits
        isPartial
        theme {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        financialProduct {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
          riskReturnLevel
        }
        suggestedFinancialProduct {
          id
        }
        ${
          canReadBillingSchedule || canReadFeeTier
            ? `feeSetting {
          ${canReadBillingSchedule ? 'applicableBillingSchedule { id frequency }' : ''}
          ${canReadFeeTier ? 'applicableFeeTier { id name }' : ''}
          ${canReadFeeTier ? 'feeTier { id name }' : ''}
          ${canReadBillingSchedule ? 'billingSchedule { id frequency }' : ''}
        }`
            : ''
        }
        statistics {
          marketValueCents
          simpleReturnAmount
          simpleReturnPercent
        }
      }
    }
  }
`;

export const TRANSITION_SUB_ACCOUNT = gql`
  mutation transitionSubAccount($input: TransitionSubAccountInput!) {
    transitionSubAccount(input: $input) {
      subAccount {
        id
      }
    }
  }
`;

export const CLOSE_SUB_ACCOUNT = gql`
  mutation closeSubAccount($input: CloseSubAccountInput!) {
    closeSubAccount(input: $input) {
      subAccount {
        id
      }
    }
  }
`;
